'use client';

import type { SwiperOptions } from 'swiper/types';
import type { ThemeSwipeProps } from '@/app/_components/widgets/theme-swipe/theme-swipe.types';
import type { FC } from 'react';
import type { HomeLogPageNameValue } from '@/app/(pages)/sub-home/[category]/constants';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PC_BREAKPOINT } from '@weberus/utils';
import { SubHeader } from '@yanolja-rnd/nol-design-system';
import ThemeSwipeItem from '@/app/_components/widgets/theme-swipe/theme-swiple-item';
import { cn } from '@/app/_shared/utils/tw-cn';

const swiperConfig: SwiperOptions = {
  slidesPerView: 'auto',
  runCallbacksOnInit: false,
  breakpoints: {
    [PC_BREAKPOINT]: {
      enabled: false,
    },
  },
};
/**
 * 테마 스와이프 위젯
 * @see {@link https://www.figma.com/design/zlHuiOHmYv1ghVDbTHUSvW/%5BGUIDE%5D-%EC%9C%84%EC%A0%AF%2F%EC%98%A4%EB%8D%94%EB%A7%81?node-id=334-58465&node-type=frame&m=dev}
 *
 * 기획 요청사항
 * @see {@link https://screen.yanolja.in/LwGrUem222cl8UPG}
 */

interface ThemeSwipeWidgetProps extends ThemeSwipeProps {
  pageNameLog: HomeLogPageNameValue;
}
export const ThemeSwipe: FC<ThemeSwipeWidgetProps> = ({ data, pageNameLog }) => {
  if (data?.items.length < 4) return null;
  const { title, subTitle, items, logMeta: widgetLogMeta } = data;
  return (
    <section className="m-16 flex w-full flex-col justify-center pc:my-40 pc:w-pc-size">
      {!!title && (
        <div className="w-full">
          <SubHeader className="px-16" subTitle={subTitle} title={title} />
        </div>
      )}
      <Swiper {...swiperConfig} className={cn('w-full', 'pc:w-auto')}>
        {items.map((item, index) => (
          <SwiperSlide
            key={`${item.title}-${index.toString()}`}
            className={cn(
              '!w-fit',
              // spaceBetween 옵션을 사용하면 ssr에서 렌더링이 깨지므로 padding-right로 대체, 마지막 요소는 padding-right를 0으로 처리
              `pr-12 last:pr-0 ${items.length < 10 ? 'pc:pr-[40px]' : 'pc:pr-[24px]'}`,
              // slidesOffsetBefore, slidesOffsetAfter 옵션을 사용하면 ssr에서 렌더링이 깨지므로 margin으로 대체
              'first:ml-[16px] last:mr-[16px] pc:first:ml-0 pc:last:mr-0',
            )}>
            <ThemeSwipeItem pageNameLog={pageNameLog} widgetLogMeta={widgetLogMeta} {...item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
